import React, { useCallback, useState, useEffect } from 'react';
import { Field, ErrorMessage } from '@atlaskit/form';
import Select from '@atlaskit/select';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/main.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import { useSitePickerContext } from '../../../../controllers/use-site-picker-context';
import useFetchJiraAvailableSites from '../../../../services/fetch-jira-available-sites';
import messages from './messages';
import type { Props, SelectOption } from './types';

const SitePicker = (props: Props) => {
	const { classNamePrefix, onChange, width = 350 } = props;
	const [, { setSitePickerState }] = useSitePickerContext();
	const { sites, error, isLoading } = useFetchJiraAvailableSites();
	const { formatMessage } = useIntl();

	const [selectedValue, setSelectedValue] = useState({});

	useEffect(() => {
		if (!sites) return;
		const currentSite = window.location.hostname.split('.')[0];
		const prefilledValue = sites?.filter((site) => site.label === currentSite)?.[0] || {};
		setSitePickerState({
			siteDomain: prefilledValue.url || '',
		});
		setSelectedValue(prefilledValue);
	}, [setSitePickerState, sites]);

	const _onChange = useCallback(
		(option: SelectOption | null) => {
			setSitePickerState({
				siteDomain: option?.url || '',
				selectedCloudId: option?.value || '',
			});
			onChange?.();
			setSelectedValue(option || {});
		},
		[setSitePickerState, onChange],
	);

	return (
		<ErrorBoundary>
			<ReportErrors packageName="jiraIssueCreate" id="JiraSitePickerSelect">
				<FieldContainer width={width}>
					<Field name="site" label={formatMessage(messages.sitePickerFieldLabel)}>
						{({ fieldProps }) => (
							<>
								<Select
									inputId={fieldProps?.id}
									value={selectedValue}
									options={sites}
									// @ts-expect-error - TS2322 - Type '(option: SelectOption | null) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
									onChange={_onChange}
									classNamePrefix={classNamePrefix}
									isLoading={isLoading}
								/>
								{error && <ErrorMessage>{formatMessage(messages.sitePickerError)}</ErrorMessage>}
							</>
						)}
					</Field>
				</FieldContainer>
			</ReportErrors>
		</ErrorBoundary>
	);
};

export default SitePicker;
